import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-question-bubble',
  templateUrl: './question-bubble.html',
  styleUrls: ['./question-bubble.scss']
})
export class QuestionBubble {
  @Input() text: string = '';
  @Output() clicked = new EventEmitter<void>();

  onClick() {
    this.clicked.emit();
  }
}